import { useEffect } from 'react';
import { FlatOrgData, FlatOrgTreeTableNode } from 'src/utils/treeNode';

const PENDING_ITEM_KEY = 'pendingOrgTableItemId';

export const setPendingOrgTableItem = (id: string) => {
  localStorage.setItem(PENDING_ITEM_KEY, id);
};

/**
 * After an org/workspace is created, expands the tree to reveal it and scrolls it into view.
 * Reads a pending item ID from localStorage (set by creation modals), expands all ancestor
 * nodes, then scrolls the row into view after the DOM updates.
 */
export const useScrollToNewItem = (
  data: FlatOrgData[],
  treeTableData: FlatOrgTreeTableNode[],
  setExpandedKeys: React.Dispatch<React.SetStateAction<Record<string, boolean>>>,
) => {
  useEffect(() => {
    const pendingId = localStorage.getItem(PENDING_ITEM_KEY);
    if (pendingId && data.length > 0) {
      localStorage.removeItem(PENDING_ITEM_KEY);

      const newExpandedKeys: Record<string, boolean> = {};
      const byId = new Map(data.map((item) => [item.id, item]));
      let current = byId.get(pendingId);
      while (current?.parentId) {
        newExpandedKeys[current.parentId] = true;
        current = byId.get(current.parentId);
      }
      setExpandedKeys(newExpandedKeys);

      setTimeout(() => {
        const row = document.querySelector(`[class*="org-row-${CSS.escape(pendingId)}"]`);
        row?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      return;
    }

    if (treeTableData.length > 0) {
      setExpandedKeys({ [treeTableData[0].key]: true });
    }
  }, [treeTableData]);
};
